import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IAddress } from '@care-portals/api-interfaces';

@Component({
  selector: 'portals-emr-address-display',
  template: `
    <span
      >{{ address?.address1 | titlecase }} {{ address?.address2 | titlecase }},
      {{ address?.city }}, {{ address?.provinceCode || address?.province }},
      {{ address?.postalCode }},
      {{ address?.countryCode }}
    </span>
  `,
  standalone: true,
  imports: [TitleCasePipe]
})
export class AddressDisplayComponent {
  @Input() address: IAddress;
}
